import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCard } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';

import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateFormatService } from '@/app/services/date-format.service';
import { NgxCurrencyDirective } from 'ngx-currency';
import { CountryService } from '@/app/services/shared/country';
import { FileManagerComponent } from '@/app/components/shared/file-manager/file-manager.component';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCard,
    MatRadioModule,
    MatDatepickerModule,
    NgxCurrencyDirective,
    FileManagerComponent,
  ],
  selector: 'app-relevant-construction-expereince',
  templateUrl: './relevant-construction-expereince.component.html',
  styleUrls: ['./relevant-construction-expereince.component.css'],
})
export class RelevantConstructionExpereinceComponent
  implements OnInit, OnChanges
{
  formGroup: FormGroup;
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  currencySymbol: any = '';
  countries: any = [];
  countryName: string = '';
  @Input() isFetchApplicantData: boolean;
  /**
   * NOTE: this is using the new files manager component. For old files,
   * they will be required to be updated using this component as well
   */
  oldConsProject1Files: any[] = [];
  deletedOldConsProject1FilesIds: any[] = [];
  oldConsProject2Files: any[] = [];
  deletedOldConsProject2FilesIds: any[] = [];
  oldConsProject3Files: any[] = [];
  deletedOldConsProject3FilesIds: any[] = [];

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent,
    private DateFormatService: DateFormatService,
    private countryServices: CountryService
  ) {}
  ngOnInit(): void {
    const isEdit = localStorage.getItem('isEdit');

    const projectId = localStorage.getItem('projectId');

    if (isEdit === 'true' && projectId) {
      // this.getPqqData();
    }

    this.formGroup = this.fb.group({
      //Construction project 1.
      cons_project_1_name: ['', Validators.required],
      cons_project_1_client: ['', Validators.required],
      cons_project_1_value: [null, Validators.required],
      cons_project_1_start_date: ['', Validators.required],
      cons_project_1_end_date: ['', Validators.required],
      cons_project_1_role: ['', Validators.required],
      cons_project_1_des: ['', Validators.required],
      cons_project_1_challenges: ['', Validators.required],
      cons_project_1_Key_Achievements: ['', Validators.required],
      consProject1FileControl: new FormArray([]),

      //Construction project 2.
      cons_project_2_name: ['', Validators.required],
      cons_project_2_client: ['', Validators.required],
      cons_project_2_value: [null, Validators.required],
      cons_project_2_start_date: ['', Validators.required],
      cons_project_2_end_date: ['', Validators.required],
      cons_project_2_role: ['', Validators.required],
      cons_project_2_des: ['', Validators.required],
      cons_project_2_challenges: ['', Validators.required],
      cons_project_2_Key_Achievements: ['', Validators.required],
      consProject2FileControl: new FormArray([]),

      //Construction project 3.
      cons_project_3_name: ['', Validators.required],
      cons_project_3_client: ['', Validators.required],
      cons_project_3_value: [null, Validators.required],
      cons_project_3_start_date: ['', Validators.required],
      cons_project_3_end_date: ['', Validators.required],
      cons_project_3_role: ['', Validators.required],
      cons_project_3_des: ['', Validators.required],
      cons_project_3_challenges: ['', Validators.required],
      cons_project_3_Key_Achievements: ['', Validators.required],
      consProject3FileControl: new FormArray([]),

      // Key Personnel
      key_personnel_name: ['', Validators.required],
      key_personnel_role: ['', Validators.required],
      key_personnel_quals: ['', Validators.required],
      key_personnel_exp: ['', Validators.required],

      //  Subcontractors and Supply Chain
      use_subcons: ['0'],
      subcons_details: [''],
      subcon_compliance_details: [''],
    });

    // If applicantData exists, patch it to the formGroup

    this.patchFormValues();
    this.countryName = this.countryServices.getProjectCountryName();
    this.getCountriesList();

    this.addOldAttachmentMapping(this.applicantData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
      this.addOldAttachmentMapping(this.applicantData);
    }
  }

  patchFormValues() {
    if (this.applicantData?.company_name) {
      const sampleProjects = this.applicantData?.sample_projects || [];
      const [project1, project2, project3] = sampleProjects;
      const getDate = (dateString: string) =>
        dateString ? new Date(dateString) : '';

      this.formGroup.patchValue({
        // Construction project 1
        cons_project_1_name: project1?.project_name || '',
        cons_project_1_client: project1?.client_name || '',
        cons_project_1_value: project1?.project_value || null,
        cons_project_1_start_date: getDate(project1?.start_date),
        cons_project_1_end_date: getDate(project1?.completion_date),
        cons_project_1_role: project1?.role || '',
        cons_project_1_des: project1?.description_of_work || '',
        cons_project_1_challenges: project1?.challenges_faced || '',
        cons_project_1_Key_Achievements: project1?.key_achievements || '',

        // Construction project 2
        cons_project_2_name: project2?.project_name || '',
        cons_project_2_client: project2?.client_name || '',
        cons_project_2_value: project2?.project_value || null,
        cons_project_2_start_date: getDate(project2?.start_date),
        cons_project_2_end_date: getDate(project2?.completion_date),
        cons_project_2_role: project2?.role || '',
        cons_project_2_des: project2?.description_of_work || '',
        cons_project_2_challenges: project2?.challenges_faced || '',
        cons_project_2_Key_Achievements: project2?.key_achievements || '',

        // Construction project 3
        cons_project_3_name: project3?.project_name || '',
        cons_project_3_client: project3?.client_name || '',
        cons_project_3_value: project3?.project_value || null,
        cons_project_3_start_date: getDate(project3?.start_date),
        cons_project_3_end_date: getDate(project3?.completion_date),
        cons_project_3_role: project3?.role || '',
        cons_project_3_des: project3?.description_of_work || '',
        cons_project_3_challenges: project3?.challenges_faced || '',
        cons_project_3_Key_Achievements: project3?.key_achievements || '',

        // Key Personnel
        key_personnel_name: this.applicantData?.key_personnel_name || '',
        key_personnel_role: this.applicantData?.key_personnel_role || '',
        key_personnel_quals:
          this.applicantData?.key_personnel_qualifications || '',
        key_personnel_exp: this.applicantData?.key_personnel_experience || '',

        // Subcontractors and Supply Chain
        use_subcons: this.applicantData?.use_subcontractors ? '1' : '0',
        subcons_details: this.applicantData?.subcontractor_scope_of_work || '',
        subcon_compliance_details:
          this.applicantData?.supply_chain_management || '',
      });
    }
  }

  getCountriesList(): void {
    this.projectsService.getCountries().subscribe({
      next: (response: any) => {
        this.countries = response.data;
        this.countries.forEach((country) => {
          if (country.name === this.countryName) {
            this.currencySymbol = country.symbol;
          }
        });
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  numberToWords(num: any) {
    // if (num === 0) return 'zero';

    const belowTwenty = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];
    const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

    function helper(n) {
      if (n === 0) return '';
      else if (n < 20) return belowTwenty[n] + ' ';
      else if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
      else
        return belowTwenty[Math.floor(n / 100)] + ' hundred ' + helper(n % 100);
    }

    let word = '';
    let index = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[index] + ' ' + word;
      }
      num = Math?.floor(num / 1000);
      index++;
    }

    return word.trim();
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Prepare projects data (sample_projects[0]?, sample_projects[1], etc.)
    const sampleProjects = [];
    for (let i = 1; i <= 3; i++) {
      const project = {
        project_name: this.formGroup.get(`cons_project_${i}_name`)?.value,
        client_name: this.formGroup.get(`cons_project_${i}_client`)?.value,
        project_value: this.formGroup.get(`cons_project_${i}_value`)?.value,
        start_date: this.DateFormatService.formatDate(
          this.formGroup.get(`cons_project_${i}_start_date`)?.value
        ),
        completion_date: this.DateFormatService.formatDate(
          this.formGroup.get(`cons_project_${i}_end_date`)?.value
        ),
        role: this.formGroup.get(`cons_project_${i}_role`)?.value,
        description_of_work: this.formGroup.get(`cons_project_${i}_des`)?.value,
        challenges_faced: this.formGroup.get(`cons_project_${i}_challenges`)
          ?.value,
        key_achievements:
          this.formGroup.get(`cons_project_${i}_Key_Achievements`)?.value || '', // Assuming `cons_project_achievements` exists or should be empty
      };

      // Only include project if it has any value
      if (Object.values(project).some((val) => val)) {
        sampleProjects.push(project);
      }
    }

    // Append sample projects to FormData
    sampleProjects.forEach((project, index) => {
      Object.keys(project).forEach((key) => {
        dataToSubmit.append(`sample_projects[${index}][${key}]`, project[key]);
      });
    });

    // Prepare key personnel data
    const keyPersonnel = {
      key_personnel_name: this.formGroup.get('key_personnel_name')?.value,
      key_personnel_role: this.formGroup.get('key_personnel_role')?.value,
      key_personnel_qualifications: this.formGroup.get('key_personnel_quals')
        ?.value,
      key_personnel_experience: this.formGroup.get('key_personnel_exp')?.value,
    };

    Object.keys(keyPersonnel).forEach((key) => {
      dataToSubmit.append(key, keyPersonnel[key]);
    });

    // Prepare subcontractor and supply chain data
    const useSubcons = this.formGroup.get('use_subcons')?.value;
    const subconsDetails = this.formGroup.get('subcons_details')?.value;
    const subconComplianceDetails = this.formGroup.get(
      'subcon_compliance_details'
    )?.value;

    dataToSubmit.append('use_subcontractors', useSubcons);
    dataToSubmit.append('subcontractor_scope_of_work', subconsDetails);
    dataToSubmit.append('supply_chain_management', subconComplianceDetails);

    // Files handling Start
    this.addUploadedFiles(dataToSubmit);
    this.addDeletedOldFilesIds(dataToSubmit);
    // Files handling End

    return dataToSubmit;
  }

  addUploadedFiles(submissionFormData) {
    // Adding files to FormData
    this.formGroup.value.consProject1FileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(
            'construction_project1_attach[]',
            uploadedFile
          );
        }
      }
    );
    this.formGroup.value.consProject2FileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(
            'construction_project2_attach[]',
            uploadedFile
          );
        }
      }
    );
    this.formGroup.value.consProject3FileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(
            'construction_project3_attach[]',
            uploadedFile
          );
        }
      }
    );
  }

  // NOTE: on submit, we append deleted files ids into data
  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldConsProject1FilesIds?.length > 0) {
      submissionFormData.append(
        'delete_construction_project1_attach_ids',
        JSON.stringify(this.deletedOldConsProject1FilesIds)
      );
    }
    if (this.deletedOldConsProject2FilesIds?.length > 0) {
      submissionFormData.append(
        'delete_construction_project2_attach_ids',
        JSON.stringify(this.deletedOldConsProject2FilesIds)
      );
    }
    if (this.deletedOldConsProject3FilesIds?.length > 0) {
      submissionFormData.append(
        'delete_construction_project3_attach_ids',
        JSON.stringify(this.deletedOldConsProject3FilesIds)
      );
    }
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep3(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.ApplicantPqqSectionsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning('Please fill the required fields', 'WARNING');
      this.formGroup.markAllAsTouched();
    }
  }

  // NOTE: on edit, we add old files to the form array
  addOldAttachmentMapping(response) {
    if (response.sustainability_initiative_attach) {
      this.oldConsProject1Files = response.construction_project1_attach || [];
    }
    if (response.sustainability_initiative_attach) {
      this.oldConsProject2Files = response.construction_project2_attach || [];
    }
    if (response.sustainability_initiative_attach) {
      this.oldConsProject3Files = response.construction_project3_attach || [];
    }
  }

  /**
   * Handling File Operations - START
   */
  handleNewFiles(filesData: {
    files: File[];
    controlName: string;
    isEmpty: boolean;
  }) {
    console.log('filesData', filesData);

    switch (filesData.controlName) {
      case 'consProject1FileControl': {
        const fileArray = this.formGroup.get(
          'consProject1FileControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      case 'consProject2FileControl': {
        const fileArray = this.formGroup.get(
          'consProject2FileControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      case 'consProject3FileControl': {
        const fileArray = this.formGroup.get(
          'consProject3FileControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      default:
        break;
    }
  }

  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'consProject1FileControl': {
        this.deletedOldConsProject1FilesIds.push(OldFileData?.file?.id);
        this.oldConsProject1Files = this.oldConsProject1Files.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      case 'consProject2FileControl': {
        this.deletedOldConsProject2FilesIds.push(OldFileData?.file?.id);
        this.oldConsProject2Files = this.oldConsProject2Files.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      case 'consProject3FileControl': {
        this.deletedOldConsProject3FilesIds.push(OldFileData?.file?.id);
        this.oldConsProject3Files = this.oldConsProject3Files.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      default:
        break;
    }
  }
  /**
   * Handling File Operations - END
   */
}
